import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that scrolls the window to the top whenever the pathname changes
 * 
 * This is useful for ensuring that when navigating to a new page i.e. via a link click, the user starts at the top of the page 
 * rather than retaining their scroll position from the previous page.
 * 
 * @returns {null} This component does not render anything to the DOM, it only has a side effect of scrolling to the top on pathname change.
 * 
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}